import { render, staticRenderFns } from "./NewProjectResources.vue?vue&type=template&id=7434775b&scoped=true"
import script from "./NewProjectResources.vue?vue&type=script&lang=js"
export * from "./NewProjectResources.vue?vue&type=script&lang=js"
import style0 from "./NewProjectResources.vue?vue&type=style&index=0&id=7434775b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7434775b",
  null
  
)

export default component.exports